<div class="permission-wrapper">
    <div class="permission-request">
        <app-dropdown [Label]="'Selecione uma cidade'" [Items]="CityOptions"
        (FieldChange)="SetSelectedCity($event)"></app-dropdown>
    </div>
</div>